import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=de24b1f4&"
import script from "./Apps.vue?vue&type=script&lang=js&"
export * from "./Apps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports